export enum Countries {
  UNITED_STATES = 'United States',
  CANADA = 'Canada',
}
